import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { DashboardPage } from "./pages/DashboardPage";
import { MarketPage } from "./pages/MarketPage";
import { NewsPage } from "./pages/NewsPage";
import { ProjectFormPage } from "./pages/ProjectFormPage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { UsersPage } from "./pages/UsersPage";
import { LoginPage } from "./pages/LoginPage";
import { ExpensesPage } from "./pages/ExpensesPage";
import { useAuth } from "./auth/AuthContext";
import { LoadingState } from "./components/Common";

export default function App() {
  const { user, loading } = useAuth();
  if (loading) return <div className="auth-loading"><LoadingState /></div>;
  if (!user) return <LoginPage />;
  return <AppShell><Routes>
    <Route path="/" element={<DashboardPage />} />
    <Route path="/projects" element={<ProjectsPage />} />
    <Route path="/projects/new" element={<ProjectFormPage />} />
    <Route path="/projects/:id" element={<ProjectFormPage />} />
    <Route path="/expenses" element={<ExpensesPage />} />
    <Route path="/market" element={<MarketPage />} />
    <Route path="/news" element={<NewsPage />} />
    {user.role === "admin" && <Route path="/users" element={<UsersPage />} />}
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></AppShell>;
}
